import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Badge from "react-bootstrap/Badge";
import { FaBan } from "react-icons/fa";

const OrderItemsModalHeader = ({packingOrder, packedItems, handleCancel, setPackedItemsInOrder, infoMessageData}) => {
    const itemsQuantity = packingOrder.items.reduce((a,b) => a + b.quantityToPack, 0);
    const packedItemsQuantity = packedItems.reduce((a,b) => a + b.packed, 0);
    //const damagedItemsQuantity = packedItems.reduce((a,b) => a + b.damaged, 0);

    const action = (packingOrder.status === "review" || packingOrder.status === "downloaded" || packedItemsQuantity === itemsQuantity)
        ? "packing"
        : "review";

    return (
        <Modal.Header>
            <Modal.Title className="flex-grow-1">
                CONTENIDO DE LA VENTA

                <Badge className="ms-2 mb-2" bg="info">
                    {itemsQuantity} ítems
                </Badge>

                <br />
                <div className="fs-6">
                    {packingOrder.shop} #{packingOrder.idShop}
            </div>
            </Modal.Title>

            <div className="align-self-start">
                <Button
                    variant="danger"
                    className="float-end ms-2 mt-1 mb-2"
                    onClick={handleCancel}
                >
                    <FaBan style={{ marginBottom: "3px" }} />
                </Button>
                <Button
                    className="float-end mt-1 mb-2"
                    variant={action === "packing" ? "success" : "warning"}
                    disabled={(action === "packing" && !packedItemsQuantity) || (infoMessageData && infoMessageData.type)}
                    onClick={() => setPackedItemsInOrder(packingOrder, packedItems)}
                >
                    { action === "packing" 
                    ? "Despachar venta " + (packedItemsQuantity !== itemsQuantity ? "incompleta" : "completa")
                    : "Enviar venta a revisión"
                    }

                    <Badge className="ms-2" bg="light" text="dark">
                        {packedItemsQuantity} ítems
                    </Badge>
                </Button>
            </div>
        </Modal.Header>
    );
}
 
export default OrderItemsModalHeader;